import * as React from "react";
import Sticky from "react-sticky-el";
import styled, { useTheme } from "styled-components";
import { useContext } from "react";
import usePluginEntities from "hooks/usePluginEntities";
import WindowDimensionsContext from "contexts/WindowDimensionsContext";
const StyledSticky = styled(Sticky)`
  position: static !important;
`;
const MessageAugmentations = ({ message }) => {
  const theme = useTheme();
  const augmentations = usePluginEntities("messageAugmentations");
  const windowDimensions = useContext(WindowDimensionsContext);
  const isSticky = windowDimensions.width >= theme.breakpoints.px.max.md;
  if (!augmentations || augmentations.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    StyledSticky,
    {
      boundaryElement: `#sticky-augmentations-boundary-${message.id}`,
      disabled: !isSticky,
      positionRecheckInterval: 400,
      scrollElement: "#sticky-augmentations-container"
    },
    /* @__PURE__ */ React.createElement("dl", null, augmentations.map(({ component: Augmentation, id }) => /* @__PURE__ */ React.createElement(Augmentation, { key: id, message })))
  );
};
export default MessageAugmentations;
